<template>
  <div class="explorer">
    <div class="uk-margin-top">
      <!-- 検索フォーム -->
      <form>
        <div class="uk-margin-small">
          <div class="uk-inline uk-margin-right uk-margin-small-bottom">
            <label class="uk-text-muted">
              カードセット
              <small>（Web版は基本のみです）</small>
            </label>
            <div>
              <label class="pointer" v-for="obj in pattern.game" :key="obj.value">
                <input type="checkbox" class="uk-checkbox mr-thin" v-model="query.game" :value="obj.value">{{obj.ja}}
              </label>
            </div>
          </div>
          <div class="uk-inline uk-margin-right uk-margin-small-bottom">
            <label class="uk-text-muted">カード種別</label>
            <div>
              <label class="pointer mr-thin" v-for="obj in pattern.type" :key="obj.value">
                <input type="radio" class="uk-radio" v-model="query.type" :value="obj.value">
                <img v-if="obj.img" :src="obj.img" class="img-symbol" :alt="obj.ja">
                <span v-else>{{obj.ja}}</span>
              </label>
            </div>
          </div>
          <div class="uk-inline uk-margin-right uk-margin-small-bottom">
            <label class="uk-text-muted">産出資源</label>
            <div>
              <label class="pointer mr-thin" v-for="obj in pattern.production" :key="obj.value">
                <input type="radio" class="uk-radio" v-model="query.production" :value="obj.value">
                <img v-if="obj.img" :src="obj.img" class="img-symbol" :alt="obj.ja">
                <span v-else>{{obj.ja}}</span>
              </label>
            </div>
          </div>
          <div class="uk-inline uk-margin-right uk-margin-small-bottom">
            <label class="uk-text-muted mr-thin">リサイクルボーナス</label>
            <div>
              <label class="pointer mr-thin" v-for="obj in pattern.recycleBonus" :key="obj.value">
                <input type="radio" class="uk-radio" v-model="query.recycleBonus" :value="obj.value">
                <div v-if="obj.img" class="img-symbol-cover">
                  <img :src="obj.img" class="img-symbol img-symbol-inner" :alt="obj.ja">
                </div>
                <span v-if="!obj.img">{{obj.ja}}</span>
              </label>
            </div>
          </div>
          <div class="uk-inline uk-margin-right uk-margin-small-bottom">
            <label class="uk-text-muted">構築完了時ボーナス</label>
            <div>
              <label class="pointer mr-thin" v-for="obj in pattern.constructBonus" :key="obj.value">
                <input type="radio" class="uk-radio" v-model="query.constructBonus" :value="obj.value">
                <div v-if="obj.img && obj.value === 'Krystallium'" class="img-symbol-cover">
                  <img v-if="obj.img" :src="obj.img" class="img-symbol img-symbol-inner" :alt="obj.ja">
                </div>
                <div v-if="obj.img && obj.value !== 'Krystallium'" class="img-symbol-cover">
                  <img v-if="obj.img" :src="obj.img" class="img-symbol-inner-token" :alt="obj.ja">
                </div>
                <span v-if="!obj.img">{{obj.ja}}</span>
              </label>
            </div>
          </div>
          <div>
            <div class="uk-inline uk-margin-small-right uk-margin-small-bottom">
              <!-- 勝利点種別 -->
              <select class="uk-select" v-model="query.victoryPoint">
                <option v-for="obj in pattern.victoryPoint" :key="obj.value" :value="obj.value">
                  {{obj.ja}}
                </option>
              </select>
            </div>
            <div class="uk-inline uk-margin-small-right uk-margin-small-bottom">
              <button type="button" class="uk-button uk-button-default bg-white" @click="formClear">
                クリア
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- 抽出件数 -->
    <div class="uk-margin-small uk-text-center">
      {{resultCards.length}}種類 ({{resultCardQuantity}}枚)
    </div>
    <!-- プレビュー -->
    <div class="uk-margin">
      <Catalog :cards="resultCards"/>
    </div>
  </div>
</template>

<script>
  import Catalog from "@/components/Catalog";
  import _ from "lodash";

  export default {
    name: 'Explorer',
    data() {
      return {
        pattern: {
          game: [
            { ja: "基本", value: "Base" },
            { ja: "荒廃と隆盛", value: "CAA" }
          ],
          type: [
            { ja: "全て", value: "" },
            { ja: "灰", img: require('../assets/symbol/type-structure.png'), value: 'Structure' },
            { ja: "黒", img: require('../assets/symbol/type-vehicle.png'), value: 'Vehicle' },
            { ja: "緑", img: require('../assets/symbol/type-resarch.png'), value: 'Research' },
            { ja: "黄", img: require('../assets/symbol/type-project.png'), value: 'Project' },
            { ja: "青", img: require('../assets/symbol/type-discovery.png'), value: 'Discovery' }
          ],
          production: [
            { ja: "全て", value: "" },
            { ja: "灰", img: require('../assets/symbol/resource-materials.png'), value: 'Materials' },
            { ja: "黒", img: require('../assets/symbol/resource-energy.png'), value: 'Energy' },
            { ja: "緑", img: require('../assets/symbol/resource-science.png'), value: 'Science' },
            { ja: "黄", img: require('../assets/symbol/resource-gold.png'), value: 'Gold' },
            { ja: "青", img: require('../assets/symbol/resource-exploration.png'), value: 'Exploration' }
          ],
          recycleBonus: [
            { ja: "全て", value: "" },
            { ja: "灰", img: require('../assets/symbol/resource-materials.png'), value: 'Materials' },
            { ja: "黒", img: require('../assets/symbol/resource-energy.png'), value: 'Energy' },
            { ja: "緑", img: require('../assets/symbol/resource-science.png'), value: 'Science' },
            { ja: "黄", img: require('../assets/symbol/resource-gold.png'), value: 'Gold' },
            { ja: "青", img: require('../assets/symbol/resource-exploration.png'), value: 'Exploration' }
          ],
          constructBonus: [
            { ja: "指定しない", value: "" },
            { ja: "赤", img: require('../assets/symbol/resource-krytallium.png'), value: 'Krystallium' },
            { ja: "投資家", img: require('../assets/symbol/financier.png'), value: 'Financier' },
            { ja: "将軍", img: require('../assets/symbol/general.png'), value: 'General' },
          ],
          victoryPoint: [
            { ja: "勝利点種別", value: "" },
            { ja: "✨ 勝利点あり", value: 'Any' },
            { ja: "🏆 不変勝利点", value: 'Direct' },
            { ja: "⬜️ 建造物コンボ", value: 'Structure' },
            { ja: "⬛️ 軍用機コンボ", value: 'Vehicle' },
            { ja: "🟩 研究コンボ", value: 'Research' },
            { ja: "🟨 巨大事業コンボ", value: 'Project' },
            { ja: "🟦 発見コンボ", value: 'Discovery' },
            { ja: "👨‍💼 投資家勝利点", value: 'Financier' },
            { ja: "👩‍✈️ 将軍勝利点", value: 'General' },
          ],
        },
        query: {
          game: ["Base"],
          type: "",
          production: "",
          recycleBonus: "",
          constructBonus: "",
          victoryPoint: ""
        },
        cards: window.cards,
      }
    },
    components: { Catalog },
    props: {},
    methods: {
      formClear() {
        // this.query.game = ["Base", "CAA"];
        this.query.type = "";
        this.query.production = "";
        this.query.recycleBonus = "";
        this.query.constructBonus = "";
        this.query.victoryPoint = "";
      }
    },
    computed: {
      resultCards() {
        var result = this.cards;
        result = this.cards.filter((card) => {
          var match = true;
          // カードセット
          if (this.query.game) {
            match = match && _.includes(this.query.game, card.game);
          }

          // カードタイプ
          if (this.query.type) {
            match = match && card.type === this.query.type
          }
          // 産出
          if (this.query.production) {
            var prod = this.query.production.toLowerCase();
            match = match && !!((Number(card.production[prod]) >= 1 || card.production[prod + "By"]))
          }
          // リサイクル
          if (this.query.recycleBonus) {
            match = match && !!card.recyclingBonus[this.query.recycleBonus.toLowerCase()];
          }
          // 建築ボーナス
          if (this.query.constructBonus) {
            if (this.query.constructBonus === "Any") {
              match = match && !!_.sum(_.values(card.constructionBonus));
            } else {
              match = match && !!card.constructionBonus[this.query.constructBonus.toLowerCase()];
            }
          }
          // 勝利点
          if (this.query.victoryPoint) {
            if (this.query.victoryPoint === "Any") {
              match = match && !!_.sum(_.values(card.victoryPoint));
            } else {
              match = match && !!card.victoryPoint[this.query.victoryPoint.toLowerCase()];
            }
          }
          return match;
        });
        return result
      },
      // 抽出されたカードの総枚数
      resultCardQuantity() {
        var quantity = 0;
        this.resultCards.forEach((card) => {
          quantity += card.qty;
        });
        return quantity;
      }
    },
  }
</script>

<style scoped>

  .pointer {
    cursor: pointer;
  }

  .mr-thin {
    margin-right: 3px;
  }

  .bg-white {
    background-color: white;
  }

  .img-symbol {
    vertical-align: top;
    height: 20px;
    border-radius: 4px;
    margin: 2px 1px auto;
    filter: brightness(110%);
  }

  .img-symbol-cover {
    display: inline-block;
    border-style: solid;
    border-color: grey;
    border-width: 0.5px 2px 1px 0;
    border-radius: 100%;
    background-color: #FFFFFF;
    box-sizing: border-box;
    vertical-align: middle;
    margin: -4px 1px 0;
    width: 20px;
    height: 20px;
  }


  .img-symbol.img-symbol-inner {
    width: 15px;
    height: 16.3px;
    vertical-align: top;
    margin-top: 1px;
    margin-left: 2px;
  }

  .img-symbol-inner-token {
    vertical-align: top;
    width: 20px;
    margin: 1px 1px auto;
    filter: brightness(110%);
  }

</style>
